// 为组件提供 install 方法，供组件对外按需引入
import Component from './src/index.vue'
import { info, defaultProps, editer } from './src/config'
Component.install = (Vue) => {
  Vue.component(Component.name, Component)
}
Component.info = info
Component.defaultProps = defaultProps
Component.editer = editer
Component.events = []
Component.dataSource = []
export default Component
